import FormEntryWorkflowStateList from "./pages/ListPage.vue";
import FormEntryWorkflowStateIndex from "./pages/IndexPage.vue";

export default [
  {
    path: "/form_entry_workflow_state",
    component: FormEntryWorkflowStateIndex,
    redirect: "/form_entry_workflow_state/list",
    name: "form_entry_workflow_state",
    children: [
      {
        path: "list",
        component: FormEntryWorkflowStateList,
        name: "form_entry_workflow_state.list",
      },
    ],
  },
];
